var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Bar',{attrs:{"data":_vm.chartData,"chart-data":_vm.chartData,"chart-id":123241,"width":100,"height":35,"styles":_vm.styles,"css-classes":_vm.cssClasses}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }